module.exports = __webpack_public_path__ + "img/tech_active_icon@2x.003214e9.png";